import { i18n } from "../translate/i18n";

export const MODULE_ACCESS_ERRORS = [
  "ERR_PLAN_FEATURE_DISABLED", "ERR_COMPANY_PLAN_REQUIRED",
  "ERR_USER_FEATURE_PERMISSION_DENIED", "ERR_CRM_DISABLED_FOR_COMPANY",
];

export const getModuleAccessMessage = (reason) => {
  const key = {
    ERR_PLAN_FEATURE_DISABLED: "planUnavailable",
    ERR_COMPANY_PLAN_REQUIRED: "planRequired",
    ERR_USER_FEATURE_PERMISSION_DENIED: "userDenied",
    ERR_CRM_DISABLED_FOR_COMPANY: "globallyUnavailable",
  }[reason] || "loadError";
  return i18n.t(`moduleAccess.${key}`);
};
